import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import { getSeoOptimization } from '@/api/seoOptimization'
import '@/components/NProgress/nprogress.less' // progress bar custom style
// import { componentsLayzyMap } from '@/config/router.config.js'
// import { setDocumentTitle, domTitle } from '@/utils/domUtil'
import { ACCESS_TOKEN, THIRD_LOGIN_REDIRECT } from '@/store/mutation-types'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

export const whiteList = [
  'home',
  'login',
  // 'design',
  'products',
  'productDetail',
  'designMode',
  'aboutUs',
  'aboutUsNext',
  'serviceDesc',
  'serviceDescNext',
  'connectUs',
  'privacyPolicy',
  'affiliateIntroduction',
  'printOnDemand',
  'productDesign',
  'helpCenter',
  'helpCenterC',
  'helpCenterCA',
  'productDesignDetail',
  'producerinfo',
  'serveJoin',
  'factoryJoin',
  'resellerJoin',
  'serviceClause',
  'refund',
  'logisticsRelated',
  'companyProfile',
  'adSpecial',
  'blog',
  'blogDetail',
  'etsy',
  'shopify',
  'shipping',
  'presetProductDetail',
  'newcomerGift',
  'affiliateLessons',
  'refundPolicy',
  'christmas',
  'woocommerce',
  'shoplazza',
  'productsCategory',
  'productsSpecial',
  'productsLevel',
  'productsTag',
  'productsBrand',
  'productsTimeliness',
  'fbactivity',
  'easter',
  'graduationsale',
  'worldcup',
  'alloverprint',
  'holiday',
  'fatherisday',
  'metalsigncustom',
  'copyrightNotice',
  'hawaiianbeachstyle',
  'halloweencustomization',
  'homeCoupon',
  'homeTransfer',
  'customchristmas',
  'customservice',
  'brandservice',
  'dropshipping',
  'bulkshipping',
  'productsFavorites',
  'groupbuyingservice',
  'freesample',
  'uniqueLove',
  'bulkorderservice',
  'vnbulkorderservice',
  'stpatrickisday',
  'eastergiftzone',
  'motherisday',
  'timeliness',
  'bestsellersforsummer',
  'halloweenparty',
  'halloween',
  'printdoors'
] // no redirect whitelist
const defaultRoutePath = '/personal_center/guide'

router.beforeEach(async (to, from, next) => {
  console.log(router)
  NProgress.start() // start progress bar
  // to.meta && typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${domTitle}`)
  getSeoOptimization({ http_url: to.path, user_id: store.getters.userInfo.id }).then(res => {
    // const head = document.getElementsByTagName('head')
    // const meta = document.createElement('meta')
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute(
        'content',
        res.data.keywords
          ? res.data.keywords
          : 'Printdoors,print-on-demand,Dropshipping,Custom Clothing,Full-Service,Custom printing'
      )
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        'content',
        res.data.description
          ? res.data.description
          : "Let's sign up for free at Printdoors now!!Start Print-On-Demand Dropshipping! Learn how to go about selling your designs through your brand without the need for inventory."
      )
    // meta.content = to.meta.content
    // head[0].appendChild(meta)
    document.title = res.data.title ? res.data.title : 'Print-On-Demand and Dropshipping online partner'
    if (to.path === '/' && to.query.token) {
      if (Vue.ls.get(THIRD_LOGIN_REDIRECT)) {
        Vue.ls.set(ACCESS_TOKEN, to.query.token, 7 * 24 * 60 * 60 * 1000)
        store.commit('SET_TOKEN', to.query.token)
        store.dispatch('GetInfo')
        next({ path: Vue.ls.get(THIRD_LOGIN_REDIRECT) })
        NProgress.done()
      }
    }
    if (Vue.ls.get(ACCESS_TOKEN) || to.query.token) {
      if (to.query.token && !Vue.ls.get(ACCESS_TOKEN)) {
        Vue.ls.set(ACCESS_TOKEN, to.query.token, 7 * 24 * 60 * 60 * 1000)
        store.commit('SET_TOKEN', to.query.token)
      }
      if (JSON.stringify(store.state.user.info) === '{}') {
        store.dispatch('GetInfo')
      }
      store.dispatch('GetSystemNoticePolling')
      if (to.name === 'affiliate') {
        next({ path: '/' })
        NProgress.done()
      } else {
        if (to.path === '/user/login') {
          next({ path: defaultRoutePath })
          NProgress.done()
        } else {
          // if (store.state.user.routers.length === 0) {
          //   store.dispatch('GetRouters').then(res => {
          //     router.addRoutes(res)
          //     const redirect = decodeURIComponent(from.query.redirect || to.path)
          //     if (to.path === redirect) {
          //       // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          //       next({ ...to, replace: true })
          //     } else {
          //       // 跳转到目的路由
          //       next({ path: redirect })
          //     }
          //     NProgress.done()
          //   })
          // } else {
          //   const redirect = decodeURIComponent(from.query.redirect || to.path)
          //   if (to.path === redirect) {
          //     next()
          //   } else {
          //     // 跳转到目的路由
          //     next({ path: redirect })
          //   }
          //   NProgress.done()
          // }
          const redirect = decodeURIComponent(from.query.redirect || to.path)
          if (to.path === redirect) {
            next()
          } else {
            // 跳转到目的路由
            next({ path: redirect })
          }
          NProgress.done()
        }
      }
    } else {
      if (to.name === 'affiliate') {
        // store.commit('SET_AFF_TOKEN', to.params.token)
        Vue.ls.set('affToken', to.params.token)
        next({ path: '/' })
        NProgress.done()
      } else {
        if (whiteList.includes(to.name)) {
          // 在免登录白名单，直接进入
          next()
          NProgress.done()
        } else {
          next({ path: '/user/login', query: { redirect: to.fullPath } })
          NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
        }
      }
    }
  })
})
// valueAddedServicesDesign
router.onError(error => {
  console.log(error, '路由报错信息')
  const pattern = /Loading chunk/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  console.log('targetPath===', targetPath)
  if (isChunkLoadFailed) {
    location.reload()
  }
})
router.afterEach(() => {
  NProgress.done() // finish progress bar
})
